export const TRANSFER_PAGE_URL = 'https://traspaso.planvital.cl/';
export const TRANSFER_ALERT_TITLE = 'Estado de traspaso';
